import { useEffect, useState } from "react";
import styles from "./style.module.scss";
import "leaflet/dist/leaflet.css";
import Button from "components/UI/Button";
import DateIcon from "assets/icons/date.svg";
import TimeIcon from "assets/icons/time.svg";
import {
  MapContainer,
  Marker,
  Popup,
  TileLayer,
  useMap,
  useMapEvents,
} from "react-leaflet";
import Input from "components/UI/Input";
import { useKeycloak } from "@react-keycloak/web";

import L from "leaflet";
import { locationController } from "utils/locationhelper";
import { InstallationModelResponse } from "types";
import LoaderSpinner from "components/UI/LoaderSpinner/LoaderSpinner";

import AuthService from "services/AuthService";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify'


let companyId = locationController();

const markerIcon = new L.Icon({
  iconUrl: require("./marker-icon.png"),
  // iconSize: new L.Point(60, 75),
  // className: 'leaflet-div-icon'
});

const DashboardMap = () => {
  const [search, setSearch] = useState("");
  const [installationDetail, setInstallationDetail] =
    useState<InstallationModelResponse>();
  const [isSearchedClicked, setButtonClicked] = useState(false);
  const { keycloak } = useKeycloak();
  const [isLoading, setIsLoading] = useState(false);

  const [coordinates, setCoordinates] = useState({
    lat: 39.910799,
    lng: 32.813684,
  });

  const auth = new AuthService(keycloak);

  const getMapData = async () => {

    auth.axios(`/InstallationOperations/GetInstallationInfo`, null, {
      email: keycloak?.tokenParsed?.email,
      companyId : companyId,
      pageSize: 25,
      page: 1,
      tesisatNo: search
    }).then((response) => {
        setIsLoading(false);
        if (response.data.success === true) {
          setInstallationDetail(
            response.data?.data?.filter((row: any) => row.tesisatNo === search)
          );

          setCoordinates({
            lat: response.data.data[0].x,
            lng: response.data.data[0].y,
          });

          setButtonClicked(true);
        } else {

          if (response.data.message) {
            toast.error(response.data.message, {
              position: toast.POSITION.TOP_RIGHT,
              theme: "colored",
            });
          }
        }
      })
      .catch((err) => 
      {
        setIsLoading(false);
 
        toast.error(err.response.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          theme: "colored",
        });

      });
  };

  const ChangeMapView = ({ coords }: any) => {
    const map = useMap();
    map.setView(coords, map.getZoom());

    return null;
  };

  return (
    <div>
      <ToastContainer />
      <MapContainer
        className={styles.map}
        center={coordinates}
        zoom={15}
        scrollWheelZoom={false}
        zoomControl={false}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        {isSearchedClicked ? (
          <Marker position={coordinates} icon={markerIcon}>
            <Popup>
              <div className={styles.headerCard}>
                <div className={styles.cardText}>
                  Tesisat No: {installationDetail?.[0]?.tesisatNo}
                </div>
                <div className={styles.cardAdress}>
                  {installationDetail?.[0]?.adres}
                </div>
                <div className={styles.cardSummary}>Özet Bilgiler</div>
                <div className={styles.cardSummaryDetail}>
                  Modem Seri No: {installationDetail?.[0]?.modemSeriNo}
                </div>
                <div className={styles.cardSummaryDetail}>
                  Sayaç Seri No: {installationDetail?.[0]?.sayacSeriNo}
                </div>
                <div className={styles.cardSummaryDetail}>
                  Modem Marka: {installationDetail?.[0]?.modemMarka}
                </div>
                <div className={styles.cardSummaryDetail}>
                  Sayac Marka: {installationDetail?.[0]?.sayacMarka}
                </div>
                <div className={styles.cardSummaryDetail}>
                  Abone Tip Tanım: {installationDetail?.[0]?.aboneTipTanim}
                </div>
                {/* <div className={styles.cardSummaryDetail}>
                  <img src={DateIcon} alt="" />

                  <div></div>
                </div>
                <div className={styles.cardSummaryDetail}>
                  <img src={TimeIcon} alt="" />
                  <div></div>
                </div> */}
                {/* <button className={styles.cardFooterBtn}>Tüm Detayları Gör</button> */}
              </div>
            </Popup>
          </Marker>
        ) : (
          ""
        )}

        <div className={styles.mapHeaderBg}></div>
        <div className={styles.header}>
          <div className={styles.input}>
            <div className={styles.left}>Tesisat Sorgulama</div>
            <div className={styles.right}>
              <Input
                label=""
                onChange={(e: any) => setSearch(e.target.value)}
                placeholder="TesisatNo"
                value={search}
              />
              <button
                onClick={() => {
                  setIsLoading(true);
                  getMapData();
                }}
              >
                {" "}
                Sorgula
              </button>
            </div>
          </div>
        </div>
        <ChangeMapView coords={coordinates} />
        {isLoading ? <LoaderSpinner /> : ""}
      </MapContainer>
    </div>
  );
};

export default DashboardMap;
